import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { currencyFormat, decimalForInput } from 'utils/format'
import { InputForm } from 'components/Form/components'
import { RequestButton } from 'components/RequestButton'
import { Container, ButtonContainer } from './styles'

export default function AdjustmentForm({ onSubmit, loading, reset }) {
  const [percentage, setPercentage] = useState('')

  useEffect(() => {
    setPercentage('')
  }, [reset])

  const handleChange = (evt) => {
    const value = decimalForInput(evt.target.value)
    setPercentage(value)
  }

  const handleClick = () => {
    onSubmit(percentage)
  }

  return (
    <Container>
      <InputForm
        fullWidth
        label="% Ajuste"
        type="text"
        name="price"
        value={currencyFormat(percentage)}
        onChange={handleChange}
      />

      <ButtonContainer>
        <RequestButton
          disabled={!percentage}
          loading={loading}
          color="primary"
          onClick={handleClick}
          text="Calcular"
        />
      </ButtonContainer>
    </Container>
  )
}

AdjustmentForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  reset: PropTypes.bool,
}

AdjustmentForm.defaultProps = {
  loading: false,
  reset: false,
}
